import React from "react";
import { Layout, Spin } from "antd";
import QurealSection from "./QurealSection";

const { Content } = Layout;

function LoadingBox({ text, height = "100px" }) {
    return (
        <div
            style={{
                width: "100%",
                height: height,
                backgroundColor: "white",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                // paddingTop: "75px",
                // paddingBottom: "75px",
                // border: "1px dashed blue",
            }}
        >
            <Spin />
            {text && (
                <p style={{ color: "gray", marginBottom: "-20px" }}>{text}</p>
            )}
        </div>
    );
}

export default LoadingBox;
